// import Eye from "../../asset/image/eye.png";
import { Button, Image, Input, Popconfirm, Select, Switch, Tag } from "antd";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  FileImageOutlined,
} from "@ant-design/icons";
import { FaQuestion, FaQuora } from "react-icons/fa6";
import logo from "../../asset/logos/Logo.png";

const alphanumericSort = (a, b, value) => {
  if (isNaN(parseInt(a[value]))) {
    return a[value]?.localeCompare(b[value]);
  }
  return a[value] - b[value];
};

const RenderActionsButtons = (value) => {
  let ButtonsArray = [];
  if (value?.Delete) {
    ButtonsArray.push(RenderDeleteButton(value.Delete));
  }
  if (value?.Edit) {
    ButtonsArray.push(RenderEditButton(value.Edit));
  }
  if (value?.View) {
    ButtonsArray.push(RenderViewButton(value.View));
  }
  if (value?.Download) {
    ButtonsArray.push(RenderDownloadButton(value.Download));
  }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        // paddingRight: "5px",
      }}
    >
      {ButtonsArray?.map((el, i) => (
        <div key={i}>{el}</div>
      ))}
    </div>
  );
};

// Delete Button
const RenderDeleteButton = (value) => {
  const { id, onClick } = value;
  return (
    <Popconfirm title="Sure to delete?" onConfirm={() => onClick(id)}>
      <Button type="primary">
        {value?.name ? (
          value?.name
        ) : (
          <p className="">
            <DeleteOutlined />
          </p>
        )}
      </Button>
      {/* <Button type="primary">{value?.name}</Button> */}
    </Popconfirm>
  );
};

// Download Button
const RenderDownloadButton = (value) => {
  return (
    <DownloadOutlined
      onClick={() => {
        window.open(value, "Download");
      }}
    />
  );
};

// Edit Button
const RenderEditButton = (value) => {
  const { id, onClick } = value;
  return (
    <Button
      type="primary"
      onClick={() => {
        onClick(id);
      }}
    >
      <p className=" ">
        <EditOutlined />
      </p>
    </Button>
  );
};

// Render View Button
const RenderViewButton = (value) => {
  const { id, onClick } = value;
  return (
    <Button
      onClick={() => {
        onClick(id);
      }}
      type="primary"
    >
      <p className=" ">
        <EyeOutlined />
      </p>
    </Button>
  );
};
const RenderViewExtraDataButton = (value) => {
  const { id, onClick, name } = value;
  return (
    <Button
      onClick={() => {
        onClick(id, name);
      }}
      type="primary"
    >
      <p className=" ">
        <EyeOutlined />
      </p>
    </Button>
  );
};

// Render Images
const ImageRanders = (value, data) => {
  let imageSrc = value;
  if (!imageSrc) {
    imageSrc = logo;
  }
  return (
    <div>
      <Image
        width={data?.imageSize?.width || 50}
        height={data?.imageSize?.height || 50}
        className={`rounded-full object-cover`}
        src={imageSrc}
        alt={value}
      />
    </div>
  );
};


export const loginRoot = "/";
export const appRoot = "/app";
export const ROUTES = {
  DASHBOARD: "/dashboard",
  Blog: "/blog",
};
export const PATHNAME = {
  DASHBOARD: "/app/dashboard",
  Blog: "/app/blog",
};

const sortBy = [
  { id: 1, Label: "A to Z", value: "ASC" },
  { id: 2, Label: "Z to A", value: "DESC" },
];
const notifyList = [
  { id: 1, Label: "Home", value: "home" },
  { id: 2, Label: "Tool", value: "tool" },
  { id: 3, Label: "Listicle", value: "list" },
  { id: 4, Label: "Blog", value: "blog" },
  { id: 5, Label: "News", value: "news" },
  { id: 6, Label: "Category", value: "category" },
];
const sizeList = [{
  value: "20x120",
  Label: "20x120",
},
{
  value: "60x60",
  Label: "60x60",
}, {
  value: "60x120",
  Label: "60x120",
}, {
  value: "80x160",
  Label: "80x160",
},
{
  value: "181x1220",
  Label: "181x1220",
},
{
  value: "250x375",
  Label: "250x375",
},
{
  value: "250x750",
  Label: "250x750",
},
{
  value: "300x300",
  Label: "300x300",
},
{
  value: "300x450",
  Label: "300x450",
},
{
  value: "300x600",
  Label: "300x600",
},
{
  value: "400x400",
  Label: "400x400",
},
{
  value: "600x600",
  Label: "600x600",
},
{
  value: "600x900",
  Label: "600x900",
},
{
  value: "600x1200",
  Label: "600x1200",
},
{
  value: "800x800",
  Label: "800x800",
},
]
const CONSTANTS = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  GETMe: null,
  TABLE: {
    BLOG: [
      {
        title: "NO.",
        dataIndex: "no",
        sorter: (a, b) => alphanumericSort(a, b, "no"),
        width: 150,
      },
      {
        title: "Image",
        dataIndex: "image",
        render: ImageRanders,
        width: 100,
      },
      {
        title: "Name",
        dataIndex: "title",
        sorter: (a, b) => alphanumericSort(a, b, "title"),
        render: (text) => <p className="font-semibold mb-0 line-clamp-2">{text}</p>,
        width: 380,
      },
      {
        title: "Date",
        dataIndex: "date",
        sorter: (a, b) => alphanumericSort(a, b, "date"),
        width: 200,
      },
      {
        title: "Actions",
        dataIndex: "edit",
        render: RenderEditButton,
        width: 80,
      },
      { title: "", dataIndex: "delete", render: RenderDeleteButton, width: 80 },
    ]
  },
  FORM_FIELD: {
    LOGIN_PAGE_MODAL: [
      {
        no: 1,
        // Label: "User Name",
        name: "name",
        id: "name",
        type: "text",
        placeholder: "User name",
        required: true,
        width: 24,
      },
      {
        no: 1,
        // Label: "Password",
        name: "password",
        width: 24,
        id: "password",
        type: "password",
        placeholder: "Password",
        required: true,
      },
    ],
    BLOG_MODAL: [
      {
        no: 1,
        Label: "Title",
        name: "title",
        id: "title",
        type: "text",
        placeholder: "Title",
        required: true,
        autoFocus: true,
      },
      {
        no: 2,
        Label: "Description",
        name: "description",
        id: "description",
        type: "textarea",
        placeholder: "Enter Description",
        required: true,
      },
      {
        no: 3,
        Label: "Overview",
        name: "overview",
        id: "overview",
        type: "SimpleRichTextArea",
        placeholder: "Enter Overview",
        required: true,
      },
      {
        no: 4,
        Label: "Image",
        name: "image",
        id: "image",
        type: "file",
        placeholder: " ",
        required: true,
        acceptFormat: "image/*",
      },
    ],
    EDIT_BLOG_MODAL: [
      {
        no: 1,
        Label: "Title",
        name: "title",
        id: "title",
        type: "text",
        placeholder: "Title",
        required: true,
        autoFocus: true,
      },
      {
        no: 2,
        Label: "Description",
        name: "description",
        id: "description",
        type: "textarea",
        placeholder: "Enter Description",
        required: true,
      },
      {
        no: 3,
        Label: "Overview",
        name: "overview",
        id: "overview",
        type: "SimpleRichTextArea",
        placeholder: "Enter Overview",
        required: true,
      },
      {
        no: 4,
        Label: "Image",
        name: "image",
        id: "image",
        type: "file",
        placeholder: " ",
        required: false,
        image: "image",
        acceptFormat: "image/*",
      },
    ],
  },

  API: {
    login: {
      type: "POST",
      endpoint: "/admin/login",
    },
    signUp: { type: "POST", endpoint: "/user/signup" },
    getMe: {
      type: "GET",
      endpoint: "/admin/profile",
    },
    getBlog: {
      type: "GET",
      endpoint: "/admin/blog",
    },
    getOneBlog: {
      type: "GET",
      endpoint: "/admin/blog/:id",
    },
    addBlog: {
      type: "POST",
      endpoint: "/admin/blog",
    },
    editBlog: {
      type: "PATCH",
      endpoint: "/admin/blog/:dataId",
    },
    deleteBlog: {
      type: "DELETE",
      endpoint: "/admin/blog/:dataId",
    },
  },

  TAB_MENU: {

  },

  FILTER: {
    BLOG: [
      {
        no: 1,
        Label: "Sort",
        name: "sort",
        id: "sort",
        type: "select",
        placeholder: "Filter By Sort",
        required: true,
        option: sortBy,
        sort: "title",
      },
    ],
  },
};
export default CONSTANTS;
